import { Geometry } from 'geojson'

export enum DatasetType {
  Bag = 'bag',
  Brk = 'brk',
  Hr = 'hr',
}

export interface Facet {
  value: string
  count: number
}

export type Facets = Record<string, Facet[]>

export interface Data {
  '@search.score': number
  id?: string
  identificatie: string
  volgnummer?: number
  huisnummer?: number
  huisletter?: string
  huisnummertoevoeging?: string
  postcode?: string
  documentdatum?: string
  documentnummer?: string
  beginGeldigheid?: string
  eindGeldigheid?: string
  typeAdresseerbaarObjectOmschrijving?: string
  typeAdres?: string
  adresseertVerblijfsobjectIdentificatie?: string
  openbareruimteIdentificatie?: string
  openbareruimteVolgnummer?: number
  openbareruimteTypeOmschrijving?: string
  openbareruimteNaam?: string
  woonplaatsIdentificatie?: string
  woonplaatsNaam?: string
  woonplaatsVolgnummer?: number
  verblijfsobjectId?: string
  verblijfsobjectIdentificatie?: string
  verblijfsobjectVolgnummer?: number
  verblijfsobjectGeconstateerd: boolean
  verblijfsobjectGeometrie?: Geometry
  verblijfsobjectOppervlakte?: number
  verblijfsobjectStatusOmschrijving?: string
  verblijfsobjectGebruiksdoelWoonfunctieOmschrijving?: string
  votGbksdlGezondheidszOms?: string
  verblijfsobjectAantalEenhedenComplex?: number
  verblijfsobjectVerdiepingToegang?: number
  verblijfsobjectAantalBouwlagen?: number
  verblijfsobjectHoogsteBouwlaag?: number
  verblijfsobjectLaagsteBouwlaag?: number
  verblijfsobjectAantalKamers?: number
  verblijfsobjectEigendomsverhoudingOmschrijving?: string
  verblijfsobjectFeitelijkGebruikOmschrijving?: string
  verblijfsobjectRedenopvoerOmschrijving?: string
  verblijfsobjectRedenafvoerOmschrijving?: string
  verblijfsobjectDocumentdatum?: string
  verblijfsobjectDocumentnummer?: string
  verblijfsobjectBeginGeldigheid?: string
  verblijfsobjectEindGeldigheid?: string
  kenmerkenInOnderzoek?: boolean
  ligplaatsIdentificatie?: string
  ligplaatsVolgnummer?: number
  ligplaatsGeconstateerd?: boolean
  ligplaatsStatusOmschrijving?: string
  ligplaatsGeometrie?: Geometry
  ligplaatsBeginGeldigheid?: string
  ligplaatsEindGeldigheid?: string
  ligplaatsDocumentdatum?: string
  ligplaatsDocumentnummer?: string
  standplaatsIdentificatie?: string
  standplaatsVolgnummer?: number
  standplaatsGeconstateerd?: boolean
  standplaatsStatusOmschrijving?: string
  standplaatsGeometrie?: Geometry
  standplaatsBeginGeldigheid?: string
  standplaatsEindGeldigheid?: string
  standplaatsDocumentdatum?: string
  standplaatsDocumentnummer?: string
  gebiedenBuurtIdentificatie?: string
  gebiedenBuurtVolgnummer?: number
  gebiedenBuurtNaam?: string
  gebiedenBuurtCode?: string
  gebiedenWijkIdentificatie?: string
  gebiedenWijkVolgnummer?: number
  gebiedenWijkNaam?: string
  gebiedenWijkCode?: string
  gebiedenStadsdeelIdentificatie?: string
  gebiedenStadsdeelVolgnummer?: number
  gebiedenStadsdeelNaam?: string
  gebiedenStadsdeelCode?: string
  gebiedenGgwgebiedIdentificatie?: string
  gebiedenGgwgebiedVolgnummer?: number
  gebiedenGgwgebiedNaam?: string
  gebiedenGgwgebiedCode?: string
  panden?: null
  gebiedenBouwblokken?: null
  gebruiksdoelOmschrijvingen: string[]
  toegangOmschrijvingen: string[]
  statusOmschrijving?: string
  openbareruimteNaamNen?: string
  verblijfsobjectBagproces?: null
  wozSoortObjectOmschrijving: string[]
}

export interface DataSelectionResult {
  '@odata.count': number
  '@search.facets'?: Facets
  value: Data[]
}
